<template>
  <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
    <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
      <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
        <h1>Aproveita <span>15 dias<br>
                    de aulas grátis</span></h1>
        <h2>
          - sem compromisso -
        </h2>
        <!-- <img src="~@/assets/img/icons/form-arrow.svg" class="tw-block tw-mx-auto tw-pointer-events-none tw-mt-2 tw-mb-0"> -->
      </div>
      <fieldset class="tw-px-5 lg:tw-px-8 tw-pt-5 tw-pb-10 lg:tw-pb-12">
        <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
          <div class="input-group input-group-name" :class="classes">
            <input type="text"
                   id="input-fullName"
                   placeholder=" "
                   v-model="fullName"
            >
            <label>
              Nome e Apelido
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" name="local" rules="required" v-slot="{ classes }">
          <div class="input-group input-group-local" :class="classes">
            <select id="input-local" v-model="local">
              <option value="" selected disabled> </option>
              <option value="274">Almada</option>
              <option value="275">Alverca</option>
              <option value="276">Amadora</option>
              <option value="331">Amora: Paivas</option>
              <option value="279">Aveiro</option>
              <option value="282">Benfica</option>
              <option value="283">Boavista</option>
              <option value="284">Braga</option>
              <option value="312">Caldas da Rainha</option>
              <option value="334">Campo Grande</option>
              <option value="287">Carcavelos</option>
              <option value="289">Coimbra</option>
              <option value="277">Constituição</option>
              <option value="310">Covilhã</option>
              <option value="342">Cruz de Pau: Paivas</option>
              <option value="308">Évora</option>
              <option value="290">Expo</option>
              <option value="291">Famalicão</option>
              <option value="311">Faro</option>
              <option value="293">Gaia</option>
              <option value="321">Gondomar</option>
              <option value="339">Gondomar: São Cosme</option>
              <option value="294">Guimarães</option>
              <option value="295">Leiria</option>
              <option value="296">Linda-a-Velha</option>
              <option value="333">Lisboa: Benfica</option>
              <option value="286">Lisboa: Campo Grande</option>
              <option value="335">Lisboa: Expo</option>
              <option value="347">Lisboa: Parque das Nações</option>
              <option value="338">Lisboa: Saldanha</option>
              <option value="309">Madeira: Funchal</option>
              <option value="298">Maia</option>
              <option value="330">Oeiras: Carcavelos</option>
              <option value="329">Oeiras: Linda-a-Velha</option>
              <option value="300">Paivas</option>
              <option value="343">Portimão</option>
              <option value="299">Porto: Matosinhos</option>
              <option value="345">Porto: Boavista|Júlio Dinis</option>
              <option value="346">Porto: Casa da Música</option>
              <option value="326">Porto: Bom Sucesso</option>
              <option value="328">Porto: Marquês</option>
              <option value="344">Porto: Rotunda da Boavista</option>
              <option value="301">Póvoa de Varzim</option>
              <option value="324">Saldanha</option>
              <option value="340">Santarém</option>
              <option value="304">São João da Madeira</option>
              <option value="327">Seixal</option>
              <option value="320">Setúbal</option>
              <option value="318">Torres Vedras</option>
              <option value="336">V. Nova de Famalicão</option>
              <option value="337">V. Nova de Gaia</option>
              <option value="332">Vila Franca de Xira: Alverca</option>
              <option value="306">Vila Real</option>
              <option value="307">Viseu</option>
            </select>
            <label :class="{ 'select-placeholder' : !local }">
              Localização
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
          <div class="input-group input-group-phone" :class="classes">
            <input type="tel"
                   id="input-phone"
                   placeholder=" "
                   v-model="phone"
                   v-mask="{mask: '999999999', placeholder: ' '}"
            >
            <label>
              Telefone
            </label>
          </div>
        </validation-provider>
        <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
          <div class="mb-2">
            <div class="form-check p-0">
              <label class="form-check-label" :class="classes">
                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                <span class="checkmark"></span>
                <span class="tw-text-black">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
              </label>
            </div>
          </div>
        </validation-provider>
        <div class="tw-text-center tw-mt-4">
          <button
              type="submit"
              class="btn-cta tw-block tw-mx-auto tw-mt-3"
              id="submit"
              :disabled="formLoading"
          >
            Aproveitar oferta
          </button>
        </div>
      </fieldset>
    </form>
  </validation-observer>
</template>

<script>
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import moment from 'moment';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            phone: '',
            local: '',

            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    methods: {
        formSubmit() {
            this.formLoading = true;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                local: this.local,
            };

            const config = {
                headers: {
                    Authorization: `Bearer ${this.$store.state.token}`,
                    Language: this.$i18n.locale,
                },
            };

            axios.post(action, data, config)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
